import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "objective-header";

const keys = addTranslations(RESOURCE_NAME, {
    unassigned: {
        en: "Unassigned",
        fr: "Non assigné",
    },
    delete: {
        en: "Delete objective",
        fr: "Supprimer l'objectif",
    },
    delete_cancel: {
        en: "Cancel",
        fr: "Annuler",
    },
    error_delete: {
        en: "Error deleting objective",
        fr: "Erreur lors de la suppression de l'objectif",
    },
    delete_cta: {
        en: "Delete",
        fr: "Supprimer",
    },
    status: {
        en: "Status",
        fr: "Statut",
    },
    status_UNKNOWN: {
        en: "Unknown",
        fr: "Inconnu",
    },
    status_DRAFT: {
        en: "In progress",
        fr: "En cours",
    },
    status_DEFINED: {
        en: "Validated",
        fr: "Validé",
    },
    status_COMMITTED: {
        en: "Committed",
        fr: "Engagé",
    },
    status_ARCHIVED: {
        en: "Archived",
        fr: "Archivé",
    },
    success_update: {
        en: "Objective updated successfully",
        fr: "Objectif mis à jour avec succès",
    },
    error_update: {
        en: "Error updating objective",
        fr: "Erreur lors de la mise à jour de l'objectif",
    },
    theme_desc: {
        en: "Select a theme or subtheme",
        fr: "Sélectionnez un thème ou un sous-thème",
    },
    delete_modal_title: {
        en: "Delete objective",
        fr: "Supprimer l'objectif",
    },
    delete_modal_description: {
        en: "You are about to delete this objective. This action can not be undone.",
        fr: "Vous êtes sur le point de supprimer cet objectif. Cette action ne peut pas être annulée.",
    },
    success_delete: {
        en: "Objective deleted successfully",
        fr: "Objectif supprimé avec succès",
    },
    autosave_display: {
        en: "Saving...",
        fr: "Enregistrement...",
    },
    autosave_display_pending: {
        en: "Saving...",
        fr: "Enregistrement...",
    },
    autosave_display_success: {
        en: "Saved",
        fr: "Enregistré",
    },
    validate_contributor: {
        en: "Contributors cannot assign an owner",
        fr: "Les contributeurs ne peuvent pas assigner un propriétaire",
    },
});

export function useObjectiveHeaderTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
